import supportTicketTypes from './support-ticket/types';
import anonymousTicketTypes from './anonymous-ticket/types';

export default {
  ...supportTicketTypes,
  ...anonymousTicketTypes,
};
